import {Button} from '@/components/Button';
import {Modal} from '@/components/Modal';
import {Typography} from '@/components/Typography';
import {PaddingBox} from '@/styled-components';
import {palette} from '@/styles';

interface IProps {
  onClose(): void;
}

export const InfoModal = ({onClose}: IProps) => {
  return (
    <Modal title="상권 비교란?" width={400} onClose={onClose}>
      <PaddingBox spacing={16}>
        <Typography
          variant="medium14"
          fontWeight="500"
          color={palette.textSecondary}
        >
          조회 중인 분석 지역의 상권 데이터를 비교할 수 있는 기능입니다.
          <br />
          · 반경 : 최대 1km 이하
          <br />
          · 다각형 : 최대 면적 3km² 이하
          <br />· 행정동 : 비교 기능 미제공
        </Typography>
      </PaddingBox>
      <PaddingBox left={16} right={16} bottom={24}>
        <Button
          variant="fill"
          size="medium"
          color="secondary"
          fullWidth
          onClick={onClose}
        >
          확인
        </Button>
      </PaddingBox>
    </Modal>
  );
};
